import { render, staticRenderFns } from "./StackedTableSort.vue?vue&type=template&id=04808424&scoped=true"
import script from "./StackedTableSort.vue?vue&type=script&lang=js"
export * from "./StackedTableSort.vue?vue&type=script&lang=js"
import style0 from "./StackedTableSort.vue?vue&type=style&index=0&id=04808424&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04808424",
  null
  
)

export default component.exports